<template>
  <div>
    <el-row style="margin: 12px 0;align-items: center;">
      <el-col :span="12" class="propsLeft">{{ label }}</el-col>
    </el-row>
    <el-row style="margin: 12px 0;align-items: flex-start;">
      <el-col :span="2"></el-col>
      <el-col :span="10" class="propsLeft" style="color: #c4c4c4;">
        <div style="display: flex;width: 90vw;flex-wrap: wrap;">
          <div :class="{ 'selectedItem': radio === index }" @click="onChange(index)" class="colorItem" v-for="(item, index) in group" :key="item.props.color" :style="{ backgroundColor: item.props.color }"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    group: {
      type: Array,
      required: true
    }
  },
  computed: {
  },
  data () {
    return {
      radio: 0
    }
  },
  methods: {
    onChange (val) {
      this.radio = val
      this.group.forEach((r, index) => {
        this.$emit('change', {
          id: r.props.id,
          valueProp: 'visible',
          value: index === val
        })
      })
    },
    setDefaultRadio () {
      for (let i = 0; i < this.group.length; i++) {
        const p = this.group[i]
        if (p.props.visible) {
          this.radio = i
          break
        }
      }
      // 默认选中第一项, 其他项的visible设置为false
      this.onChange(this.radio)
    },
    changeColor (id, color) {
      this.$emit('change', {
        id: id,
        valueProp: 'color',
        value: color
      })
    },
    loseFocus (id) {
      this.$store.commit('loseFocus', id)
    },
    innerColor (r) {
      if (r && r.props && r.props.color) {
        return r.props.color?.toUpperCase()
      }
      return ''
    }
  },
  mounted () {
    this.setDefaultRadio()
  }
}
</script>

<style lang="scss" coped>
.color-trigger {
  width: 40px;
  height: 40px;
  border-color: lightgray;
}
.colorItem {
  width: 40px;
  height: 40px;
  flex: none;
  border: 2px solid lightgray;
  margin-right: 5px;
  margin-top: 5px;
}
.selectedItem {
  border-color: #409EFF;
}
</style>
